import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { MeterProps } from "./Meter.types";
import "./Meter.scss";

/** How full the meter is, 0–100, clamped to the range. */
export const getMeterPercent = (value: number, max: number, min: number = 0): number => {
    if (!(max > min)) {
        return 0;
    }

    const percent = ((value - min) / (max - min)) * 100;

    return Math.max(0, Math.min(100, percent));
};

/**
 * A slim bar for a value within a range, such as an outcome against a target (B11 Mätare).
 * The value is told by role="meter" and its aria values, not by the bar alone.
 */
const Meter: FunctionComponent<MeterProps> = ({ value, max, min = 0, valueText, label, className }) => (
    <div
        className={classNames("Meter", className)}
        role="meter"
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuetext={valueText}
        aria-label={label}
    >
        <div className="Meter-fill" style={{ width: getMeterPercent(value, max, min) + "%" }} />
    </div>
);

export default Meter;
